import type { LabeledValuePayload } from '@Application/Users/UserStatuses/Actions/userStatusesFetched';
import type { VerificationProgressPayload } from '@Application/Beneficiaries/Documents/Actions/documentFetched';

/**
 * One row of `GET …/documents`, also the fields the detail (`GET …/documents/{document}`) shares
 * with the summary — `status` and `progress` are those of the document itself. `documentType` is a
 * relation, `{ id }` only: the label is resolved client-side via `DocumentTypesListView.labelOf`,
 * never carried on this payload.
 */
export type DocumentPayload = {
	readonly id: number;
	readonly title: string;
	readonly documentType: { readonly id: number };
	readonly createdAt: string;
	readonly status: LabeledValuePayload;
	readonly progress: VerificationProgressPayload;
};

export type DocumentsFetchedPayload = {
	totalRecords: number;
	results: DocumentPayload[];
};

export type DocumentsFetchedAction = {
	type: 'DOCUMENTS_FETCHED';
	payload: DocumentsFetchedPayload;
	facilityId: number;
	subjectId: number;
	typeKey: string;
};

export default (
	payload: DocumentsFetchedPayload,
	facilityId: number,
	subjectId: number,
	typeKey: string,
): DocumentsFetchedAction => ({
	type: 'DOCUMENTS_FETCHED',
	payload,
	facilityId,
	subjectId,
	typeKey,
});
